import { EventTypeIdentifier } from '../enums';
import { Event, EventType } from '../interfaces';

export const getAvailableEventTypes = (event: Event, eventTypesToDisplay: EventType[] = []): EventType[] => {
  // The basic logic is described in https://haydenai.atlassian.net/browse/CLOUD-2994
  if (!event || !event.fleet_id) {
    return [];
  }

  if (window.Cypress) {
    // enable ET change during Cypress tests
    return eventTypesToDisplay;
  }

  // If MTA, disallow any changes
  if (event.fleet_id === '4e9c24c6-489f-4f2c-9f10-5ab265c2e3d2') {
    // MTA
    return [];
    // If WMATA:
    // Allow:  bus lane <-> bus lane -parking <-> bus lane-moving
    // Disallow: Bus Stop type ↔︎ all other type, All other type → bus lane type
  }
  if (event.fleet_id === 'e11cc71c-c921-4451-bdf1-2413782adf7a') {
    // WMATA
    const currentEventType = event.event_type_identifier;

    const isBusLaneType = currentEventType.startsWith(EventTypeIdentifier.BUS_LANE);
    if (isBusLaneType) {
      return eventTypesToDisplay?.filter((item: EventType) => item.identifier.startsWith(EventTypeIdentifier.BUS_LANE));
    }

    const isBusStopType = currentEventType.startsWith(EventTypeIdentifier.BUS_STOP);
    if (isBusStopType) {
      return [];
    }

    return eventTypesToDisplay?.filter((item: EventType) => !item.identifier.startsWith(EventTypeIdentifier.BUS_LANE));
  }

  // All other fleets, allow everything
  return eventTypesToDisplay;
};
